import React from 'react';
import {
	Datagrid,
	List,
	Show,
	Edit,
	SimpleShowLayout,
	SimpleForm,
	TextField,
	DateField,
	SelectField,
	ReferenceField,
	Labeled,
	SelectInput,
	EditButton,
	Filter,
} from 'react-admin';
import makeStyles from '@mui/styles/makeStyles';
import {
	WithMasterPermissions,
} from '../DataProviderExtension/authExtension';
import UserProfileField from '../components/UserProfileField';

const deletedAtFilterChoices = [
	{ id: 'false', name: 'без удаленных' },
	{ id: 'true', name: 'только удаленные' },
];

export const statuses = { onChecking: 'onChecking', checked: 'checked', rejected: 'rejected' };

export const reviewStatusChoices = [
	{ id: statuses.onChecking, name: 'на проверке' },
	{ id: statuses.checked, name: 'проверен' },
	{ id: statuses.rejected, name: 'отклонен' },
];

const useStyles = makeStyles({
	deletedAt: { color: 'red' },
});

const DeletedAtListField = (props) => {
	const classes = useStyles();

	return <DateField source="deletedAt" showTime className={classes.deletedAt} {...props} />;
};

const DeletedAtField = ({ record, label, ...rest }) => Boolean(record?.deletedAt) && (
	<Labeled label={label}>
		<DeletedAtListField record={record} {...rest} />
	</Labeled>
);

export const editReview = (props) => {
	return (
		<Edit {...props} title="Отзывы">
			<SimpleForm>
				<TextField label="Имя пользователя" source="name" />
				<TextField label="Текст сообщения" source="message" />
				<DeletedAtField label="Удален" />
				<SelectInput label="Статус" source="statusMessage" choices={reviewStatusChoices} />
			</SimpleForm>
		</Edit>
	);
};

export const ShowReview = (props) => {
	return (
		<Show {...props} title="Отзывы">
			<SimpleShowLayout>
				<UserProfileField label="Пользователь" source="user.id" />
				<ReferenceField label="Партнер" source="business.id" reference="Business">
					<TextField source="title.short" />
				</ReferenceField>
				<TextField label="Адрес" source="address" />
				<TextField label="Имя пользователя" source="name" />
				<TextField label="Рейтинг" source="rating" />
				<TextField label="Текст сообщения" source="message" />
				<DateField label="Дата визита" source="dateOfVisit" />
				<DateField label="Дата отправки" source="dateWrittenRating" showTime />
				<DeletedAtField label="Удален" />
				<SelectField label="Статус" source="statusMessage" choices={reviewStatusChoices} />
				<WithMasterPermissions>
					<EditButton />
				</WithMasterPermissions>
			</SimpleShowLayout>
		</Show>
	);
};


const ReviewFilter = (props) => (
	<Filter {...props}>
		<SelectInput
			label="Статус"
			source="statusMessage"
			choices={reviewStatusChoices}
			alwaysOn
		/>
		<SelectInput
			label="Удален"
			source="deletedAt"
			choices={deletedAtFilterChoices}
			alwaysOn
			parse={(v) => (v === '' ? undefined : { $exists: (v === 'true') })}
			format={({ $exists }) => {
				if ($exists === undefined) {
					return '';
				}
				return $exists ? 'true' : 'false';
			}}
		/>
	</Filter>
);

const CHECKED_BACKGROUND_COLOR = '#eaffea';
const REJECTED_BACKGROUND_COLOR = '#ffdede';
const reviewRowStyle = (record) => {
	let backgroundColor = 'white';

	switch (record?.statusMessage) {
		case statuses.checked:
			backgroundColor = CHECKED_BACKGROUND_COLOR;
			break;
		case statuses.rejected:
			backgroundColor = REJECTED_BACKGROUND_COLOR;
			break;
		default:
			break;
	}

	return {
		backgroundColor,
	};
};

export const listReview = (props) => {
	return (
		<List
			{...props}
			title="Отзывы"
			sort={{ field: 'dateWrittenRating', order: 'ASC' }}
			filters={<ReviewFilter />}
			filterDefaultValues={{
				statusMessage: statuses.onChecking,
				deletedAt: { $exists: false },
			}}
		>
			<Datagrid rowClick="show" rowStyle={reviewRowStyle}>
				<ReferenceField label="Партнер" source="business.id" reference="Business">
					<TextField source="title.short" />
				</ReferenceField>
				<TextField label="Адрес" source="address" />
				<TextField label="Имя пользователя" source="name" />
				<TextField label="Рейтинг" source="rating" />
				<TextField label="Текст сообщения" source="message" />
				<DateField label="Дата визита" source="dateOfVisit" />
				<DateField label="Дата отправки" source="dateWrittenRating" showTime />
				<SelectField label="Статус" source="statusMessage" choices={reviewStatusChoices} />
				<DeletedAtListField label="Удален" />
				<WithMasterPermissions>
					<EditButton />
				</WithMasterPermissions>
			</Datagrid>
		</List>
	);
};
